<template>
    <div class="cooperate-form">
        <div class="content-header">
            <el-table :data="commentList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="周数" prop="periodDesc" width="120"></el-table-column>
                <el-table-column label="内容">
                    <template slot-scope="scope">
                        <p v-html="scope.row.commit" style="text-align: left"></p>
                    </template>
                </el-table-column>
                <el-table-column label="时间" prop="createTime" width="150"></el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        :hide-on-single-page="formInline.pageSize>=recordsTotal"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordsTotal">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

    //定义组件
    export default {
        data() {
            return {
                cooperateType:{
                    userInterview:{
                        type:1,
                        title:'用户访谈'
                    },
                    growth:{
                        type:2,
                        title:'学习成长'
                    },
                    cooperate:{
                        type:3,
                        title:'周报'
                    },
                },
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    questionClassId:1,
                    periodId:'',
                    voteType:2
                },
                commentList:[],
                recordsTotal:0
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.formInline.questionClassId = this.sectionClassId
            this.getCooperativeComment()
        },
        methods: {
            getCooperativeComment() {
                this.$store.dispatch('cooperativeCommentInfo',this.formInline).then(res=>{
                    this.commentList = res.list
                    this.recordsTotal = res.total
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeComment()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeComment()
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cooperative/cooperativeDiscuss.vue